import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { CardDashboardTradesLoading } from '../../../../../card/dashboard/trades/card-loading/card-dashboard-trades-loading';
import Skeleton from '../../../../skeleton';
import { CardTitle } from '../../../../../card/title/card-title';

export const SkeletonDashboardCardsAllTime: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <CardDashboardTradesLoading fields={['totalPortfolioValue']}>
            <div className="relative flex h-full flex-col items-start justify-between overflow-hidden rounded-large bg-body bg-[url('/images/card-stats/all-time-bg.svg')] bg-[length:auto_90%] bg-[position:102%_300%] bg-no-repeat p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[length:auto_10rem] max-md:bg-[position:102%_110%]">
                <div>
                    <CardTitle title={t('layout.statisticsCard.allTime.title')} />
                </div>
                <div className="text-large leading-large font-black text-text">
                    <Skeleton height={2} />
                </div>
            </div>
        </CardDashboardTradesLoading>
    );
});
